<section class="upload-single-section">
    <label class="upload-button mat-button mat-accent">
        <input type="file"
               onclick="this.value = null"
               (change)="onSelectFile($event)">
        <span class="mat-button-wrapper">
            {{ 'files.actions.select.fullLabel' | translate }}
        </span>
        <!-- tags to fit with material buttons design -->
        <div class="mat-button-ripple mat-ripple">
        </div>
        <div class="mat-button-focus-overlay">
        </div>
    </label>
    <span class="file-name"> {{file?.name}} </span>
    <button mat-raised-button
            color="accent"
            [disabled]="isLoading || !file"
            (click)="startUpload()">
        <mat-icon aria-label="Upload button"
                  *ngIf="!isLoading">file_upload</mat-icon>
        <mat-spinner [diameter]="24"
                     *ngIf="isLoading"></mat-spinner>
        {{'files.actions.upload.fullLabel' | translate}}
    </button>
    <button mat-icon-button
            color="accent"
            *ngIf="file"
            (click)="cancelFile()">
        <mat-icon aria-label="Cancel">close</mat-icon>
    </button>
    <!-- <app-upload-progress *ngIf="file" [file]="file"></app-upload-progress> -->
    <div *ngIf="isNameError"
         class="name-error">
        {{ 'files.uploadStates.nameError.shortLabel' | translate:{name: allowedFileName} }}
    </div>
</section> 
